/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface EventsOverview
 */
export interface EventsOverview {
  /**
   *
   * @type {string}
   * @memberof EventsOverview
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof EventsOverview
   */
  eventName: string;
  /**
   *
   * @type {Date}
   * @memberof EventsOverview
   */
  eventDate: Date;
}

/**
 * Check if a given object implements the EventsOverview interface.
 */
export function instanceOfEventsOverview(value: object): value is EventsOverview {
  if (
    (!("eventName" in (value as Record<string, any>)) &&
      !("event_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["eventName"] === undefined &&
      (value as Record<string, any>)["event_name"] === undefined)
  )
    return false;
  if (
    (!("eventDate" in (value as Record<string, any>)) &&
      !("event_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["eventDate"] === undefined &&
      (value as Record<string, any>)["event_date"] === undefined)
  )
    return false;
  return true;
}

export function EventsOverviewFromJSON(json: any): EventsOverview {
  return EventsOverviewFromJSONTyped(json, false);
}

export function EventsOverviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EventsOverview {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    eventName: json["event_name"],
    eventDate: new Date(json["event_date"]),
  };
}

export function EventsOverviewToJSON(json: any): EventsOverview {
  return EventsOverviewToJSONTyped(json, false);
}

export function EventsOverviewToJSONTyped(
  value?: Omit<EventsOverview, "uuid"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    event_name: value["eventName"],
    event_date: value["eventDate"].toISOString().substring(0, 10),
  };
}
